import { Transform } from 'class-transformer';

import { PageCriteria } from '../../../shared/model/local/pagination/page-criteria';
import { BooleanConversion } from '../../../shared/helper/transform.helper';

export class MedicalCasePageCriteria extends PageCriteria {
  @Transform(BooleanConversion)
  archivedEq?: boolean;

  constructor() {
    super();
  }
}
